import React, { useEffect, useState } from 'react'
import { constants } from '../../misc/constants';
import { BaseConfig } from '../BaseConfig';
import Button2 from '../general/button2';
import CorePopUp from '../../cvp-webgames-core/Components/ui/react/core-pop-up';

import { UIProperties } from '../../cvp-webgames-core/Components/ui/UIProperties';

import "./alert-ui.css"
import Tools from '../../cvp-webgames-core/Misc/Tools';
import { TextHtmlTagType, generalAudioCaching, parseDynamicHtml, setFocus } from '../../misc/tools';
const AlertUI = (props: UIProperties<AlertUIConfig>) => {
	const [isInit, setIsInit] = useState(false);
	useEffect(() => {
		if(!isInit) {
			setIsInit(true);
			const url = generalAudioCaching.getItemByKey(generalAudioCaching.audioKeys.chime_bell_ding_01).src;

			Tools.playOneShotSound(url);
		}
	}, []);

	return (
		<div className="modal-disable-select alert-uicontainer black-overlay" style={{
			zIndex: 10000
		}}>
			<div aria-label='message' className='alert-uicontainer-inner center-element'>
				<CorePopUp title={props.parameters.title} style={{
					backgroundColor: 'lightgray'
				}} onRenderContent={() => {
					return (
						<div className='alert-uicontent'>
							<div className='alert-uicontent-content-container main-content-inner'>
								<div className='alert-uicontent-content-container-inner white-text' dangerouslySetInnerHTML={{ __html: parseDynamicHtml(props.parameters.htmlContent) }}>
								</div>
							</div>
							<div className='alert-uicontent-confirm-bttn-container center-element-horizontal'>
								{props.parameters.noBttn ? (
									<div style={{
										height: '100%'
									}}>
										<div style={{
											width: '45%',
											height: '100%',
											display: 'inline-block',
											marginRight: '50px'
										}}>
											<Button2 width= '100%'
												idFor508='alert-content-top'
												height= '100%'
												hoverBgColor={'rgb(191, 221, 255)'}
												onClick= {() => {
													if(props.parameters.okButton.onClick) {
														props.parameters.okButton.onClick()
													}
													if((window as any)['focus-last-el-alert']) {
														
														setFocus((window as any)['focus-last-el-alert'],null, 50);
													}
												}}
												onRenderContent= {() => {
													return (
														<div>
															<p className='alert-uicontent-btn-confirm-text center-element-vertical black-text'>{props.parameters.okButton.title}</p>
														</div>
													)
												}}
												isSelected= {false}
												ariaLabel= {props.parameters.okButton.title}></Button2>
										</div>
										<div style={{
											width: '45%',
											height: '100%',
											display: 'inline-block'
										}}>
											<Button2 width= '100%'
												height= '100%'
												idFor508='alert-content-bottom'
												hoverBgColor={'rgb(191, 221, 255)'}
												onClick= {() => {
													if(props.parameters.noBttn.onClick) {
														props.parameters.noBttn.onClick()
													}
													if((window as any)['focus-last-el-alert']) {
														setFocus((window as any)['focus-last-el-alert'],null, 50);
													}
												}}
												onRenderContent= {() => {
													return (
														<div>
															<p className='alert-uicontent-btn-confirm-text center-element-vertical black-text'>{props.parameters.noBttn.title}</p>
														</div>
													)
												}}
												isSelected= {false}
												ariaLabel= {props.parameters.noBttn.title}></Button2>
										</div>
									</div>
								) : (
									<div  style={{
										height: '100%'
									}}>
										<Button2 width= '100%'
										height= '100%'
										idFor508='alert-content-bottom'
										hoverBgColor={'rgb(191, 221, 255)'}
										onClick= {props.parameters.okButton.onClick}
										onRenderContent= {() => {
											return (
												<div>
													<p className='alert-uicontent-btn-confirm-text center-element-vertical black-text'>{props.parameters.okButton.title}</p>
												</div>
											)
										}}
										isSelected= {false}
										ariaLabel= {props.parameters.okButton.title}></Button2>
									</div>
								)}
								
							</div>
						</div>
					);
				}}></CorePopUp>
			</div>
		</div>
	);

};

export interface AlertUIConfig extends BaseConfig {
	title: string;
	htmlContent: string;
	okButton: AlertUIButton;
	noBttn?: AlertUIButton;
}

export interface AlertUIButton {
	title: string;
	onClick: () => void;
}

export default AlertUI;